module.exports = __webpack_public_path__ + "static/media/yk_2.11a184a0.jpg";